(() => {
  const polish = (root) => {
    root.querySelectorAll('.product-single__description, .product-single__description-full').forEach((description) => {
      description.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
        heading.classList.toggle('kingpin-copy-callout', heading.textContent.trim().length > 140);
      });
      description.querySelectorAll('p').forEach((paragraph) => {
        const text = paragraph.textContent.trim();
        const strong = paragraph.querySelector('strong, b');
        const isLabel = text.length > 0 && text.length <= 90 && strong && strong.textContent.trim() === text;
        paragraph.classList.toggle('kingpin-copy-label', Boolean(isLabel));
        const hasContent = paragraph.querySelector('img, iframe, video, audio, svg, input, button, select, textarea, a, object, embed');
        paragraph.classList.toggle('kingpin-copy-spacer', text.length === 0 && !hasContent);
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => polish(document), { once: true });
  } else {
    polish(document);
  }
  document.addEventListener('shopify:section:load', (event) => polish(event.target));
})();
